module.exports = __webpack_public_path__ + "media/images/flags/in-b41a546a46b9397f74e1fe802fdf94d2.svg";